import { render, staticRenderFns } from "./CompactRiskScorePercentage.vue?vue&type=template&id=4745b805&scoped=true"
import script from "./CompactRiskScorePercentage.vue?vue&type=script&lang=js"
export * from "./CompactRiskScorePercentage.vue?vue&type=script&lang=js"
import style0 from "./CompactRiskScorePercentage.vue?vue&type=style&index=0&id=4745b805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745b805",
  null
  
)

export default component.exports